






















































































































import CommonBase from "../CommonBase";
import {Inject, Component, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import {CardUserdata, GuiUserlisting, Person, PersonMergeResult, TmcPersonLink} from "../../modules/models";
import PersonMarker from "../PersonMarker.vue";

@Component({
    components: {
        "at-person-marker": PersonMarker
    }
})
export default class UserMerge extends CommonBase{
    @Inject()
    api!: Api;

    @Prop({default: false})
    value!: boolean;

    @Prop()
    fromPersonData!: CardUserdata;

    private toPersonData: CardUserdata | null = null;

    get fromPerson(): Person | null {
        return this.fromPersonData != null ? this.fromPersonData.person : null;
    }
    get toPerson(): Person | null {
        return this.toPersonData != null ? this.toPersonData.person : null;
    }

    loading = false;
    searchTxt = "";
    @Watch("fromPersonData", {immediate: true})
    onFromPersonDataChanged() {
        this.searchTxt = this.fromPersonData.person.name;
        this.search();
    }

    searchResult: GuiUserlisting[] = [];

    async search() {
        this.loading = true;
        try {
            const listing = await this.api.userList(this.searchTxt, 1);
            // filter out the fromPerson from search result
            // filter out unverified persons from search result
            this.searchResult = listing.filter((u) => u.guid != this.fromPersonData.person.guid && u.verified);
        } catch(err) {
            this.emitError(err);
        }
        this.loading = false;
    }

    async loadToPerson(guid: string) {
        this.loading = true;
        try {
            this.toPersonData = await this.api.userData(guid);
        } catch (err) {
            this.emitError(err);
        }
        this.loading = false;
    }

    async doMerge(fromGuid: string, toGuid: string) {
        if(!this.loading) {
            this.loading = true;
            try {
                this.mergeResult = await this.api.mergePersons(fromGuid, toGuid);
                this.$emit("at-user-merged", this.mergeResult);
            } catch(err) {
                this.emitError(err);
            }
            this.loading = false;
        }
    }

    mergeResult: PersonMergeResult | null = null;

    close() {
        this.toPersonData = null;
        this.mergeResult = null;
        this.$emit("input", false);
    }

    tmcidsTxt(tmcids: TmcPersonLink[]): string {
        return tmcids.length > 0 ? "Proresult time ref: "+ tmcids.map((t) => `${t.companyOrgNum} => ${t.tmcDbName}-${t.tmcEmployeeNum}`).join(", ") : "";
    }
}
